<template>
    <g>
        <path :style="{ fill: color }" d="M79.3,43c-0.9-2.6-3-2.4-4.6-1.6c0.2-4.6,0.1-9.6-0.5-14.4c-0.1-1.1-0.4-2.4-0.9-3.6
		c-1.5-4-4.9-8.2-10.8-10.4c-0.9-0.3-1.8-0.6-2.8-0.8c-0.7-0.2-1.5-0.3-2.3-0.4c-1.2-0.2-2.5-0.3-3.9-0.3c-0.1,0-0.1,0-0.2,0h0h0
		c-8.9,0-14.2,3.7-17,7.9c-1.7,2.6-2.5,5.3-2.7,7.6c0,0,0,0.1,0,0.1c0,0.4-0.1,0.8-0.1,1.2c-0.2,2.9-0.4,5.8-0.4,8.7
		c0,1.7,0,3.2,0,4.5c-1.6-1-4-1.5-5,1.3c-0.6,1.7,0.5,4.4,1.6,6.7c1.1,2.3,1.7,4.1,3.4,4.1c0.4,0,0.8-0.2,1.1-0.5
		c0.5,2.9,1.2,5.3,2,7c1.2,2.5,3.3,5.5,5.8,8.2v5.8c0,0.9-0.5,1.6-1.3,1.9l-3.3,1.1c0,0-2.3,0.5-2.3,2.3c0,3.2,7,11.4,18.8,11.4
		s18.8-8.3,18.8-11.4c0-1.8-2.3-2.3-2.3-2.3l-3.3-1.1c-0.8-0.3-1.3-1-1.3-1.9v-5.6c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.2-0.3
		c0.1-0.1,0.3-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.3-0.4
		c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.2,0.2-0.3,0.3-0.5
		c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.1,0.1-0.2c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.1,0.1-0.2
		c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0,0,0-0.1c0.4-0.8,0.7-1.6,0.9-2.3c0.3-1.3,0.7-3,1-5c0.2,0.1,0.5,0.2,0.7,0.2c1.7,0,2.3-1.8,3.4-4.1
		C78.8,47.4,79.9,44.7,79.3,43z"/>
        <path style="opacity:6.000000e-02;fill:#1A1A1A;" d="M72.5,58.6C71,64,61.7,75.2,54.5,75.4c-0.1,0-0.1,0-0.2,0
		c6.1-0.2,13.5-12.1,14.9-16.3c0.8-2.5,1.5-16.5,1.5-20.5c0-4-0.4-9.6-3.5-11.4c-3.1-1.8-7.4,1.7-14,0.6c-6.6-1-11.1-4.2-12.5-3.3
		c-3.5,2.1-3,7.2-3.3,9.7c-0.4,2.5-1.5,4.3-2.3,6c-0.8,1.6-1.1,4.8-1.6,4.8c-0.4,0-0.3-12,0.3-17.9c0.6-6.2,5.3-15.6,19.7-15.6
		s20.2,9.1,21,15.5C75.9,39.6,73.9,53.1,72.5,58.6z"/>
    </g>
</template>

<script>
    export default {
        name: 'Body1',
        props: {
            color: {
                type: String,
                required: true,
            },
        },
    }
</script>
